import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect, Link } from 'react-router-dom';
import queryString from 'query-string';
import * as settings from '../globals/settings';
import * as digitalIdApi from '../api/digitalIdApi';
import ReactGA from 'react-ga';
import { doLogin, setFakeLoginState, fakeAuth } from '../actions/auth'
import Loading from '../components/loading'
import Footer from '../components/footer'
// FIXME Remove
import { fakeUser, fakeLabResults } from '../util/fakeData'
import { setUser, receiveLabResults, setErrorState, createDeviceId } from '../actions/api'
import { clearEverything } from '../actions/auth'

import NavBar from '../components/navbar'

import '../css/styles.css';

class LoginScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: "",
            errEmail: null,
            loginErrorMessage: null,
            isLoginError: false,
            errCode: null,
            loginAlert: false
        }
    }

    componentDidMount() {
        if(this.props.location){
            if(this.props.location.state){
                this.setState({loginAlert: !!this.props.location.state.loginAlert})
            }
        }

        this.props.dispatch(clearEverything());
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.strings !== prevProps.strings && prevState.errCode === this.state.errCode && prevState.errCode !== null){
            if(this.state.errCode === 'ALO'){
                this.setState({isLoginError: true, loginErrorMessage: this.props.strings.ALO_ERROR_MESSAGE});
            } else if(this.state.errCode === 'ARE'){
                this.setState({isLoginError: true, loginErrorMessage: this.props.strings.LOGIN_FAILED_MESSAGE});
            } else if(this.state.errCode === 'ADE'){
                this.setState({isLoginError: true, loginErrorMessage: this.props.strings.LOGIN_FAILED_MESSAGE});
            } else if(this.state.errCode === 'UVA'){
                this.setState({isLoginError: true, loginErrorMessage: this.props.strings.UVA_ERROR_MESSAGE});
            } else if(this.state.errCode === 'IUE'){
                this.setState({isLoginError: true, loginErrorMessage: this.props.strings.IUE_ERROR_MESSAGE});
            } else if(this.state.errCode === 'UE') {
                this.setState({isLoginError: true, loginErrorMessage: this.props.strings.LOGIN_FAILED_MESSAGE});
            }
        }
    }

    handleUsernameChange = (e) => {
        this.setState({username: e.target.value});
    }

    handlePasswordChange = (e) => {
        this.setState({password: e.target.value});
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({isLoginError: false, loginErrorMessage: null, loginAlert: false});
        this.props.dispatch(doLogin(this.state.username, this.state.password))
            .then((results) => {
                ReactGA.event({
                    category: 'Login event',
                    action: 'Login Successful',
                    label: 'login-success'
                });
                this.props.history.push("/app");
            })
            .catch(err => {
                // Clear username and password state after failing to login
                this.setState({username: "", password: ""})

                if(err !== null && err !== undefined){
                    if(err.errorObj.results){
                        this.setState({ errEmail: err.errorObj.results.split(":")[1] });
                    }

                    if(err.code === 'ALO'){
                        this.setState({isLoginError: true, loginErrorMessage: this.props.strings.ACCOUNT_LOCKED_MESSAGE_1+this.props.strings.ACCOUNT_LOCKED_MESSAGE_2+this.props.strings.ACCOUNT_LOCKED_MESSAGE_3, errCode: err.code});
                    } else if(err.code === 'ARE'){
                        this.setState({isLoginError: true, loginErrorMessage: this.props.strings.LOGIN_FAILED_MESSAGE, errCode: err.code});
                    } else if(err.code === 'ADE'){
                        this.setState({isLoginError: true, loginErrorMessage: this.props.strings.LOGIN_FAILED_MESSAGE, errCode: err.code});
                    } else if(err.code === 'UVA'){
                        this.setState({isLoginError: true, loginErrorMessage: this.props.strings.UNVALIDATED_ERROR_MESSAGE_1+this.props.strings.UNVALIDATED_ERROR_MESSAGE_2+this.props.strings.UNVALIDATED_ERROR_MESSAGE_3+this.state.errEmail+this.props.strings.UNVALIDATED_ERROR_MESSAGE_4+this.props.strings.UNVALIDATED_ERROR_MESSAGE_5, errCode: err.code});
                    } else if(err.code === 'IUE'){
                        this.setState({isLoginError: true, loginErrorMessage: this.props.strings.IUE_ERROR_MESSAGE, errCode: err.code});
                    } else if(err.code === 'UE') {
                        this.setState({isLoginError: true, loginErrorMessage: this.props.strings.LOGIN_FAILED_MESSAGE, errCode: err.code});
                    } else {
                        this.setState({isLoginError: true, loginErrorMessage: this.props.strings.LOGIN_FAILED_MESSAGE, errCode: err.code});
                    }
                }
                ReactGA.event({
                    category: 'Login event',
                    action: 'Login Failed',
                    label: 'login-fail'
                });
                
            });;
    }

    handleSubmitVerify = (e) => {
        e.preventDefault();
        setTimeout(() => this.props.history.push("/emailVerification"), 500);
    }

    handleSubmitBypass = (e) => {
        e.preventDefault();
        this.props.dispatch(fakeAuth());
        setTimeout(() => this.props.history.push("/app"), 500);
    }

    handleCreateError = (e) => {
        e.preventDefault();
        this.props.dispatch(setErrorState(true, "fake error...", false));
    }

    renderLoginError() {
        if(this.state.loginAlert){
            return (
                <div>
                    <span style={{color: 'red', fontWeight: 'bold'}}>
                        {this.props.strings.LOGGED_OUT_INACTIVITY}
                    </span>
                </div>
            );
        }

        if (this.state.isLoginError === false || this.state.loginErrorMessage === null) {
            return null;
        } else {
        if(this.state.errCode === 'ALO'){
                return (
                    <div>
                        <span style={{color: 'red', fontWeight: 'bold'}}>
                            {" "+this.props.strings.ALO_PASS_RESET_MESSAGE_1}<a className="forget-label" href="/manitoba/usernameRequest">{this.props.strings.FORGOT_UN_LINK}</a>{this.props.strings.ALO_PASS_RESET_MESSAGE_2}<a className="forget-label" href="/manitoba/resetPasswordRequest">{this.props.strings.FORGOT_PASS_LINK}</a>
                        </span>
                    </div>
                );
            } else if(this.state.errCode === 'UVA'){
                return (
                    <div>
                        <span style={{color: 'red'}}>
                            {this.props.strings.ERROR_LABEL}
                            {" "+this.props.strings.UNVALIDATED_ERROR_MESSAGE_1} <b>{this.props.strings.UNVALIDATED_ERROR_MESSAGE_2}</b>
                            {this.props.strings.UNVALIDATED_ERROR_MESSAGE_3}{this.state.errEmail}{this.props.strings.UNVALIDATED_ERROR_MESSAGE_4}
                            <a href={this.props.language === "en" ? "https://sharedhealthmb.ca/covid19/test-results/help-questions/" : "https://covid19.soinscommunsmb.ca/covid19/resultats-test/demande-daide/"}>
                                {this.props.strings.UNVALIDATED_ERROR_MESSAGE_5}
                            </a>
                            {this.props.strings.UNVALIDATED_ERROR_MESSAGE_6}
                        </span>
                    </div>
                );
            }
            else if(this.state.errCode === 'IUE'){
                return (
                    <div>
                        <span style={{color: 'red', fontWeight: 'bold'}}>
                            {this.props.strings.ERROR_LABEL}{" "+this.props.strings.IUE_ERROR_MESSAGE}
                        </span>
                    </div>
                );
            } else if(this.state.errCode === 'IUE'){
                return (
                    <div>
                        <span style={{color: 'red', fontWeight: 'bold'}}>
                            {this.props.strings.ERROR_LABEL}<br/>
                            {this.props.strings.IUE_ERROR_MESSAGE}
                        </span>
                    </div>
                );
            } else {
                return (
                    <div>
                        <span style={{color: 'red'}}>{this.state.loginErrorMessage}</span>
                    </div>
                );
            }
        }
    }

    renderMainContent() {
        return (
            <>
                <div className="row justify-content-center">
                    <div className="container">
                        <div className="row justify-content-center low-padding" style={{paddingBottom: 3, paddingTop: 30}}>
                            <span className="main-title">Manitoba SH-CORD</span>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <form onSubmit={this.handleSubmit} className="formMargin">
                        <div className="row justify-content-center">
                            <button type="submit" class="btn btn-primary custom-button">Login</button>
                        </div>
                    </form>
                </div>
            </>
        );
    }

    renderVerifyButton() {
        if (settings.DEBUG == "true") {
            return (
                <div className="row justify-content-center" style={{marginTop: 30}}>
                    <form onSubmit={this.handleSubmitVerify}>
                        <div className="row justify-content-center">
                            <Link to="/email_validation">REMOVE ME VERIFY!</Link>
                        </div>
                    </form>
                </div>
            );
        } else {
            return null;
        }
    }

    renderBypassButton() {
        if (settings.DEBUG == "true") {
            return (
                <div className="row justify-content-center" style={{marginTop: 30}}>
                    <form onSubmit={this.handleSubmitBypass}>
                        <div className="row justify-content-center">
                            <button type="submit" class="btn btn-primary custom-button">REMOVE ME BYPASS!</button>
                        </div>
                    </form>
                </div>
            );
        } else {
            return null;
        }
    }

    renderErrorButton() {
        if (settings.DEBUG == "true") {
            return (
                <div className="row justify-content-center" style={{marginTop: 30}}>
                    <form onSubmit={this.handleCreateError}>
                        <div className="row justify-content-center">
                            <button type="submit" class="btn btn-primary custom-button">REMOVE ME CREATE ERROR!</button>
                        </div>
                    </form>
                </div>
            );
        } else {
            return null;
        }
    }

    // FIXME Remove fake login!!!!
    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        } else if (this.props.isLoadingLogin === true) {
            return <Loading />
        }
        return (
          <div className="container-full">
            <NavBar language={this.props.language}/>
            <div className="container justify-content-center align-items-center">
              <div class="alert alert-info" role="alert">
                    <h4>{this.props.strings.LOGIN_LABEL}</h4>
                  <p>
                    {this.props.strings.LOGIN_PAGE_TITLE} <Link to="/register">{this.props.strings.REGISTER_NOW_LABEL}</Link>.
                  </p>
                  <h7 className="helpForm">{this.props.strings.HELP_FORM_STRING_1}<a target="_blank" href={this.props.strings.HELP_FORM_LINK}>{this.props.strings.HELP_FORM_STRING_2}</a>{this.props.strings.HELP_FORM_STRING_3}
                  </h7>
              </div>
                    <form onSubmit={this.handleSubmit} className="formMargin">
                        <div class="form-group">
                            <label for="username-input">{this.props.strings.USERNAME_LABEL}</label>
                            <input class="form-control" id="username-input" placeholder={this.props.strings.USERNAME} onChange={this.handleUsernameChange}/>
                            <a className="forget-label" href="/manitoba/usernameRequest">{this.props.strings.FORGOT_UN_LINK}</a>
                        </div>
                        <div class="form-group">
                            <label for="password-input">{this.props.strings.PASSWORD_LABEL}</label>
                            <input class="form-control" type="password" id="password-input" placeholder={this.props.strings.PASSWORD} onChange={this.handlePasswordChange}/>
                            <a className="forget-label" href="/manitoba/resetPasswordRequest">{this.props.strings.FORGOT_PASS_LINK}</a>
                        </div>
                        {this.props.loginAlert}
                        {this.renderLoginError()}
                        <div className="row justify-content-center">
                            <button type="submit" class="btn btn-primary custom-button">{this.props.strings.LOGIN_BUTTON_LABEL}</button>
                        </div>
                    </form>
                    <div className="row justify-content-center">
                    </div>
                    {this.renderVerifyButton()}
                    {this.renderBypassButton()}
                    {this.renderErrorButton()}
            </div>
            <footer>
                <Footer />
            </footer>
          </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizeUrl: state.auth.authorizeUrl,
        auth: state.auth,
        isLoadingLogin: state.auth.isLoadingLogin,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        strings: state.language.strings,
        language: state.language.language,
        isError: state.api.isError,
        loginAlert: state.auth.loginAlert,
    }
}

const ConnectedLoginScreen = connect(
    mapStateToProps
)(LoginScreen);
export default withRouter(ConnectedLoginScreen);
